<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          RELATÓRIO / PUBLICAÇÃO RANKING DE FRANQUIAS
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" xs="6" md="4">
              <v-select
                :items="types"
                v-model="type"
                label="Tipo de Comparação"
                hide-details
                @change="handleChangeType()"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" xs="6" md="4">
              <v-autocomplete
                :items="franchises"
                v-model="franchises_selected"
                label="Ocultar Franquias Relatório"
                :item-text="(item) => `${item.code} - ${item.description}`"
                item-value="id"
                hide-details
                dense
                outlined
                multiple
                small-chips
                :loading="loadingFranchise"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">
                    <span
                      >{{ item.code }} -
                      {{ item.description.substring(0, 25) }}...</span
                    >
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ franchises_selected.length - 1 }} outros)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="4" lg="4">
              <v-select
                multiple
                label="Tipo de Relatório"
                :items="typesReports"
                hide-details
                dense
                outlined
                v-model="reports"
                small-chips
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-checkbox
                v-model="publication"
                hide-details
                label="Publicar Ranking"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="exportReport('pdf')"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-simple-table fixed-header dense width="400px" height="250px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Tipo</th>
                      <th class="text-left">Nome</th>
                      <th class="text-right">Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="rel in reportsView" :key="rel.type">
                      <td>{{ getTypeName(rel.type) }}</td>
                      <td>{{ rel.nome.replace("publications/", "") }}</td>
                      <td>
                        <v-btn
                          class="white--text"
                          small
                          color="indigo"
                          target="_blank"
                          :href="getUrlReport(rel)"
                        >
                          <v-icon>mdi-cloud-download</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="linkDownload"
      >
        <v-card>
          <v-card-text class="pa-10">
            <v-btn
              class="ma-5 white--text justify-center d-flex"
              large
              color="indigo"
              target="_blank"
              :href="download.link"
              @click="() => (linkDownload = false)"
            >
              <v-icon left>mdi-cloud-download</v-icon>
              CLIQUE AQUI PARA BAIXAR
            </v-btn>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="linkDownload = false">
              FECHAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import * as CompanyAPI from "@/api/requests/CompanyRequest";

export default {
  components: { Alert },
  directives: {},
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    types: [
      { value: 1, text: "Faturamento" },
      { value: 2, text: "Número de Pares" },
    ],
    type: "",
    classifications: [
      { value: 1, text: "($) Valor" },
      { value: 2, text: "(%) Percentual" },
    ],
    classification: "",
    loading: false,
    messageAlert: "",
    showAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
    franchises_selected: [],
    franchises: [],
    loadingFranchise: false,
    linkDownload: false,
    reportsView: [],
    download: {
      name: "",
      link: "#",
    },
    typesReports: [
      { value: "billing", text: "Faturamento" },
      { value: "pairs", text: "Pares" },
      { value: "accessories", text: "Acessórios" },
    ],
    reports: ["billing", "pairs", "accessories"],
    publication: false,
    url: "",
  }),
  computed: {},
  created() {
    this.url = URL;
    let dateNow = new Date();
    let yearNow = dateNow.getFullYear();
    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    initialize() {
      this.getFranchises();
    },
    async getFranchises() {
      this.loadingFranchise = true;
      try {
        let res = await CompanyAPI.getAll("?type=fra");
        this.franchises = res.sort((a, b) =>
          a.description < b.description ? -1 : 1
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingFranchise = false;
      }
    },
    async exportReport() {
      if (this.month === "") {
        alert("Selecione o mês para continuar");
        return;
      }
      if (this.year === "") {
        alert("Selecione o ano para continuar");
        return;
      }
      if (this.reports.length === 0) {
        alert("Selecione pelo menos 1 tipo de relatório para poder continuar");
        return;
      }
      // return false;
      this.loading = true;
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.month = this.month;
      data.year = this.year;
      data.exceptions = this.franchises_selected;
      data.reports = this.reports;
      data.publication = this.publication;
      console.log(data);

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}report/ranking-franchise-publication`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.reportsView = response.reports;
        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getUrlReport(rel) {
      return this.publication
        ? `${this.url}publications/download/${rel.nome}`
        : `${this.url}report/download/${rel.nome}`;
    },
    getTypeName(type) {
      let selected = this.typesReports.find((item) => item.value === type);
      if (selected) {
        return selected.text;
      }
      return "Tipo não identificado";
    },
  },
};
</script>
